import createTableStore from "ds/components/Table/store/useTableStore";

import {
  INTEGRATION_USED_BY_TABLE_COLUMNS_CONFIG,
  INTEGRATION_USED_BY_TABLE_STORAGE_KEY,
} from "./constants";

const useIntegrationUsedByTableStore = createTableStore({
  storageKey: INTEGRATION_USED_BY_TABLE_STORAGE_KEY,
  config: INTEGRATION_USED_BY_TABLE_COLUMNS_CONFIG,
});

export default useIntegrationUsedByTableStore;
